<template>
  <v-card class="ma-0 pa-0">
    <v-toolbar color="indigo" dense fixed>
      <v-toolbar-title class="white--text">
        Dichiarazioni del Capobarca
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- Filtri (mostra commesse) -->
      <v-tooltip bottom v-if="filtri_visible === false">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="filtri_visible = true"
            small
            v-bind="attrs"
            v-on="on"
            ><v-icon color="purple lighten-2">mdi-filter</v-icon></v-btn
          >
        </template>
        <span>Filtri</span>
      </v-tooltip>
      <v-tooltip bottom v-else>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="ripristina"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="purple lighten-2">mdi-filter-off</v-icon>
          </v-btn>
        </template>
        <span>Ripristina</span>
      </v-tooltip>

      <v-spacer></v-spacer>
      <!-- Chiudi Diario -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="goBack" small v-bind="attrs" v-on="on"
            ><v-icon color="error">mdi-keyboard-backspace</v-icon></v-btn
          >
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-2 pa-0"></v-card-text>
    <template>
      <div>
        <v-data-table
          :headers="headers"
          :items="commesse"
          item-key="nome"
          class="elevation-0"
          :search="search"
          height="80vh"
          fixed-header
        >
          <!-- Toolbar superiore -->
          <template v-slot:top>
            <v-row align="center" justify="center" v-if="filtri_visible">
              <v-col cols="3">
                <v-autocomplete
                  @change="filtra"
                  :items="elem_commessa"
                  :item-text="(e) => e.barca"
                  item-value="barca"
                  label="Barca"
                  v-model="barca_search"
                >
                  <template slot="append">
                    <v-icon
                      @click="
                        barca_search = '';
                        filtra();
                      "
                      color="primary"
                    >
                      mdi-filter-off
                    </v-icon>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="commessa_search"
                  label="Matricola"
                  @change="filtra"
                >
                  <template slot="append">
                    <v-icon
                      @click="
                        commessa_search = '';
                        filtra();
                      "
                      color="primary"
                    >
                      mdi-filter-off
                    </v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                  @change="filtra"
                  :items="elem_commessa"
                  :item-text="(e) => e.des_commessa"
                  item-value="des_commessa"
                  label="Descrizione"
                  v-model="cod_search"
                >
                  <template slot="append">
                    <v-icon
                      @click="
                        cod_search = '';
                        filtra();
                      "
                      color="primary"
                    >
                      mdi-filter-off
                    </v-icon>
                  </template>
                </v-autocomplete>
              </v-col>
              <!-- data calendar -->
              <v-col cols="3">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="289"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="data_formattata"
                      label="Data"
                      prepend-icon="mdi-calendar"
                      v-on="on"
                      readonly
                    >
                      <template slot="append">
                        <v-icon
                          @click="
                            date = '';
                            filtra();
                          "
                          color="primary"
                        >
                          mdi-filter-off
                        </v-icon>
                      </template></v-text-field
                    >
                  </template>
                  <v-date-picker
                    v-model="date"
                    @input="
                      menu = false;
                      filtra();
                    "
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item="{ item }">
            <tr>
              <!-- Bottone di modifica -->
              <td style="text-align: left">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="clickModificaCommessa(item)"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary"> mdi-pencil </v-icon>
                    </v-btn>
                  </template>
                  <span>Modifica Dichiarazione</span>
                </v-tooltip>
              </td>

              <!-- Bottone di gestione ore -->
              <td style="text-align: left">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="clickModificaOreSquadra(item)"
                      :disabled="item.id_responsabile === null"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary"> mdi-account-clock </v-icon>
                    </v-btn>
                  </template>
                  <span>Registro Ore Squadra</span>
                </v-tooltip>
              </td>

              <!-- Colonna del questionario -->
              <td style="text-align: left">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="clickChecklist(item)"
                      :disabled="
                        item.checklist_dettaglio.filter(
                          (e) => e.abilitato == 1 && e.valore == 0
                        ).length > 0
                      "
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        :color="item.completata === 1 ? 'success' : 'primary'"
                      >
                        mdi-file-question
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Rispondi al Questionario</span>
                </v-tooltip>
              </td>

              <!-- Colonna della data ultima modifica -->
              <td style="text-align: left">
                {{
                  item.date_mod && item.date_mod.length > 0
                    ? `${item.date_mod.substring(
                        8,
                        10
                      )}/${item.date_mod.substring(
                        5,
                        7
                      )}/${item.date_mod.substring(0, 4)}`
                    : "N/A"
                }}
              </td>

              <!-- Colonna della barca -->
              <td style="text-align: left">
                {{ item.barca }}
              </td>

              <!-- Colonna della matricola -->
              <td style="text-align: left">
                {{ item.matricola }}
              </td>

              <!-- Colonna delle ore -->
              <td style="text-align: left">
                <div style="display: inline-block; width: 100px">
                  {{ item.tot_ore_giorno_commessa == null ? 0 : item.tot_ore_giorno_commessa }}

                  <v-btn icon @click="clickOreParziali(item)">
                    <v-icon color="primary"> mdi-clipboard-edit </v-icon>
                  </v-btn>
                </div>
              </td>

              <!-- colonne dei valori dinamici -->
              <td
                style="text-align: left"
                v-for="elem in items_colonne"
                :key="elem.value"
              >
                <v-icon
                  :color="
                    item.checklist_dettaglio.filter(
                      (e) => e.des == elem.des && e.valore == 1
                    ).length > 0
                      ? 'success'
                      : 'error'
                  "
                  v-if="isColumnEnabled(item, elem.des)"
                >
                  {{
                    item.checklist_dettaglio.filter(
                      (e) => e.des == elem.des && e.valore == 1
                    ).length > 0
                      ? "mdi-check-circle"
                      : "mdi-close-circle"
                  }}
                </v-icon>
                <!--<v-icon color="grey lighten-1" v-else>
                  mdi-checkbox-blank-circle
                </v-icon>-->
              </td>

              <!-- Colonna di eliminazione -->
              <!--<td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="clickElimina(item)"
                      small
                      v-bind="attrs"
                      v-if="
                        cod_profilo === 'SVIL' ||
                        cod_profilo === 'CNXBOX' ||
                        cod_profilo === 'Admin' ||
                        cod_profilo === 'manager'
                      "
                      v-on="on"
                    >
                      <v-icon color="error"> mdi-delete </v-icon>
                    </v-btn>
                  </template>
                  <span>Rispondi al Questionario</span>
                </v-tooltip>
              </td>-->
            </tr>
          </template>

          <!-- Qui ci sono i vecchi slot delle fasi fisse -->
          <!--
          <template v-slot:[`item.rif_prem`]="{ item }">
            <v-icon color="success">
              {{ item.rif_prem === 1 ? "mdi-check-circle" : "" }}</v-icon
            >
          </template>

          <template v-slot:[`item.guscio`]="{ item }">
            <v-icon color="success">
              {{ item.guscio === 1 ? "mdi-check-circle" : "" }}</v-icon
            >
          </template>

          <template v-slot:[`item.coperta`]="{ item }">
            <v-icon color="success">
              {{ item.coperta === 1 ? "mdi-check-circle" : "" }}</v-icon
            >
          </template>

          <template v-slot:[`item.vassoio`]="{ item }">
            <v-icon color="success">
              {{ item.vassoio === 1 ? "mdi-check-circle" : "" }}</v-icon
            >
          </template>

          <template v-slot:[`item.calzata`]="{ item }">
            <v-icon color="success">
              {{ item.calzata === 1 ? "mdi-check-circle" : "" }}</v-icon
            >
          </template>

          <template v-slot:[`item.magazzino`]="{ item }">
            <v-icon color="success">
              {{ item.magazzino === 1 ? "mdi-check-circle" : "" }}</v-icon
            >
          </template>-->
        </v-data-table>
      </div>
    </template>
    <!-- Dialog di modifica avanzamento montaggio -->
    <v-dialog v-model="specifica_barca">
      <ModificaDiario
        @click_chiudi="chiudiDialog"
        :riga_sel="elemento_sel"
        @salva_dichiarazione="handleSalvaDichiarazione"
        :visible="specifica_barca"
      />
    </v-dialog>

    <!-- Dialog di modifica distribuzione ore -->
    <v-dialog v-model="modifica_ore_diario">
      <ModificaOreDiario
        @chiudi_modifica_ore="chiudiModificaOre"
        @click_chiudi="chiudiModificaOre"
        :items_colonne="items_colonne"
        :riga_sel="elemento_sel"
        @salvate_modifiche="handleSaveModOre"
        :visible="modifica_ore_diario"
      />
    </v-dialog>

    <!-- Dialog Questionario -->
    <v-dialog v-model="questionario_visible">
      <RisposteDialog
        @chiuso_dialog_selezione="questionario_visible = false"
        @click_chiudi="chiudiQuestionario"
        :readonly="elemento_sel.completata === 1"
        :riga_sel="elemento_sel"
        @salvato_questionario="handleSalvatoQuestionario"
        :visible="questionario_visible"
      />
    </v-dialog>

    <!-- Dialog di conferma eliminazione -->
    <v-dialog v-model="conferma_eliminazione_dialog" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"
            >Conferma Eliminazione</v-toolbar-title
          >
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="font-size: 18px">
            Confermi l'eliminazione della Dichiarazione selezionata?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container class="ma-0 pa-0">
            <v-row align="center" justify="center">
              <v-col cols="12" align="center" justify="center">
                <!-- Bottone di annullamento -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="conferma_eliminazione_dialog = false"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="error"> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Annulla</span>
                </v-tooltip>

                <!-- Bottone di conferma -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="eliminaDichiarazione"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                  <span>Conferma</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog delle ore parziali -->
    <v-dialog v-model="dialog_ore_parziali" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Ore Parziali </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_ore_parziali = false;"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-data-table
            :items="items_ore_parziali"
            :headers="headers_ore_parziali"
          ></v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import ModificaDiario from "@/components/ELECTRICALMARINE/ModificaDiario.vue";
import ModificaOreDiario from "@/components/ELECTRICALMARINE/ModificaOreDiario.vue";
import moment from "moment/moment";
import RisposteDialog from "@/components/ELECTRICALMARINE/RisposteDialog.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Elemento {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] =
          arg[c.nome] != undefined
            ? c.complex === false
              ? arg[c.nome]
              : JSON.parse(JSON.stringify(arg[c.nome]))
            : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "barca", complex: false, default_val: null },
      { nome: "completata", complex: false, default_val: 0 },
      { nome: "data_consegna", complex: false, default_val: "" },
      { nome: "date_mod", complex: false, default_val: "" },
      { nome: "cod_articolo_child", complex: false, default_val: "" },
      { nome: "des_articolo_child", complex: false, default_val: "" },
      { nome: "des_commessa", complex: false, default_val: "" },
      { nome: "id_articolo_avo", complex: false, default_val: null },
      { nome: "id_articolo_child", complex: false, default_val: null },
      { nome: "id_responsabile", complex: false, default_val: null },
      { nome: "id_checklist", complex: false, default_val: null },
      { nome: "id_commessa", complex: false, default_val: null },
      { nome: "id_commessa_dettaglio", complex: false, default_val: null },
      { nome: "id_commessa_avo", complex: false, default_val: null },
      { nome: "id_commessa_riepilogo", complex: false, default_val: null },
      { nome: "matricola", complex: false, default_val: "" },
      { nome: "ore", complex: false, default_val: null },
      { nome: "checklist_dettaglio", complex: false, default_val: new Array() },
    ];

    return campi;
  }
}

export default {
  name: "Diario",
  components: {
    ModificaDiario,
    ModificaOreDiario,
    // Modules: () => import("@/components/TOOLS/Modules"),
    RisposteDialog,
    SnackbarQV,
  },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      barca_search: "",
      cod_profilo: null,
      commessa_search: "",
      date: "",
      cod_search: "",
      elemento_sel: new Elemento(),
      filtri_visible: false,
      id_utente: null,
      item_sel: null,
      search: "",

      // Modal bool
      conferma_eliminazione_dialog: false,
      dialog_ore_parziali: false,
      specifica_barca: false,
      modifica_ore_diario: false,
      menu: false,
      overlay: false,
      questionario_visible: false,

      // Array
      commesse: [],
      elem_commessa: [],
      headers: [
        /*{
          text: "Rif. Prem.",
          value: "rif_prem",
          sortable: false,
        },
        {
          text: "Guscio",
          value: "guscio",
          sortable: false,
        },
        {
          text: "Coperta",
          value: "coperta",
          sortable: false,
        },
        {
          text: "Vassoio",
          value: "vassoio",
          sortable: false,
        },
        {
          text: "Calzata",
          value: "calzata",
          sortable: false,
        },
        {
          text: "Magazzino",
          value: "magazzino",
          sortable: false,
        },
        {
          text: "Fly",
          value: "magazzino",
          sortable: false,
        },
        {
          text: "Elimina",
          value: "elimina",
          sortable: false,
        },*/
      ],
      headers_ore_parziali: [
        {
          text: "Fase",
          value: "des",
          sortable: false,
        },
        {
          text: "Ore",
          value: "tot_ore_giorno_commessa",
          sortable: false,
        },
      ],
      headers_stabili: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
        },
        {
          text: "Modifica Ore",
          value: "modifica_ore",
          sortable: false,
        },
        {
          text: "Checklist",
          value: "checklist",
          sortable: false,
        },
        {
          text: "Data Ultimo Montaggio",
          value: "date_mod",
          sortable: false,
        },
        {
          text: "Barca",
          value: "barca",
          sortable: false,
        },
        {
          text: "Matricola",
          value: "matricola",
          sortable: false,
        },
        {
          text: "Ore",
          value: "tot_ore_giorno_commessa",
          sortable: false,
        },
      ],
      items_autorizzazioni: new Array(),
      items_colonne: new Array(),
      items_diario: new Array(),
      items_ore_parziali: new Array(),
    };
  },
  computed: {
    data_formattata() {
      return this.date != "" ? moment(this.date).format("DD/MM/YYYY") : "";
    },
  },
  watch: {},
  methods: {
    buildHeaders() {
      this.headers = Array.from(this.headers_stabili);
      this.items_colonne.forEach((c) => {
        this.headers.push({
          text: c.des,
          value: c.des,
          sortable: false,
        });
      });
    },
    chiudiDialog() {
      this.specifica_barca = false;
    },
    chiudiModificaOre() {
      this.modifica_ore_diario = false;
    },
    chiudiQuestionario() {
      this.questionario_visible = false;
    },
    clickChecklist(arg) {
      this.elemento_sel = new Elemento(arg);
      this.questionario_visible = true;
    },
    clickElimina(arg) {
      this.elemento_sel = Object.assign({}, arg);
      this.conferma_eliminazione_dialog = true;
    },
    clickModificaCommessa(item) {
      console.log(JSON.stringify(item));

      // Registro l'elemento selezionato.
      this.elemento_sel = new Elemento(item);

      // Apro la finestra di dialogo per le modifiche
      this.specifica_barca = true;
    },
    clickModificaOreSquadra(item) {
      this.elemento_sel = new Elemento(item);
      this.modifica_ore_diario = true;
    },
    async clickOreParziali(arg) {
      await this.getOreParziali(arg.id_commessa);

      this.dialog_ore_parziali = true;
    },
    data_search() {
      return this.data_search != ""
        ? moment(this.data_search).format("DD/MM/YYYY")
        : "";
    },
    eliminaDichiarazione() {
      // Eseguo la chiamata per eliminare una dichiarazione.
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "deletediario",
          token: localStorage.user_token,
          id_commessa: this.elemento_sel.id_commessa,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.conferma_eliminazione_dialog = false;
            this.getDiario();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità tecnica rilevata, codice: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },

    filtra() {
      /* Preparo un array temporaneo in cui
       * collezionare gli commesse filtrate */
      let commesse_tmp = [];
      this.elem_commessa.forEach((e) => {
        commesse_tmp.push(Object.assign({}, e));
      });

      // Filtro per data
      if (this.data_formattata != "") {
        let res = [];
        commesse_tmp.forEach((elem) => {
          const data_formattata = moment(elem.data_spedizione).format(
            "DD/MM/YYYY"
          );
          if (data_formattata === this.data_formattata) {
            res.push(Object.assign({}, elem));
          } else
            console.log(`no buono: ${data_formattata} ${this.data_formattata}`);
        });
        commesse_tmp = [];
        res.forEach((e) => {
          commesse_tmp.push(Object.assign({}, e));
        });
      }

      //Filtro per barca
      if (this.barca_search != "") {
        let res = [];
        commesse_tmp.forEach((elem) => {
          if (elem.barca === this.barca_search) {
            res.push(Object.assign({}, elem));
          }
        });
        commesse_tmp = [];
        res.forEach((e) => {
          commesse_tmp.push(Object.assign({}, e));
        });
      }

      // Filtro per Matricola
      if (this.commessa_search != "") {
        let res = [];
        commesse_tmp.forEach((elem) => {
          if (elem.cod_articolo === this.commessa_search) {
            res.push(Object.assign({}, elem));
          }
        });
        commesse_tmp = [];
        res.forEach((e) => {
          commesse_tmp.push(Object.assign({}, e));
        });
      }

      // Filtro per Descrizione
      if (this.cod_search != "") {
        let res = [];
        commesse_tmp.forEach((elem) => {
          if (elem.des_commessa == this.cod_search) {
            res.push(Object.assign({}, elem));
          }
        });

        commesse_tmp = [];
        res.forEach((e) => {
          commesse_tmp.push(Object.assign({}, e));
        });
      }

      // Ricostruisco le commesse visualizzate in base agli commesse filtrati.
      this.commesse = Array.from(commesse_tmp);
    },
    getDiario() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getdiario",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.elem_commessa = new Array();
            this.commesse = new Array();
            console.log(res.data.result.checklist.length);
            res.data.result.checklist.forEach((e) => {
              /* Ceteris paribus, se sono un capobarca e se sono il capobarca
               * di questa specifica barca, la aggiungo all'elenco. */
              if (
                (this.cod_profilo === "capobarca" &&
                  e.id_responsabile == this.id_utente) ||
                this.cod_profilo != "capobarca"
              ) {
                this.elem_commessa.push(Object.assign({}, e));
                this.commesse.push(Object.assign({}, e));
              }
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Errore tecnico con codice ${res.status}`
            );
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    getOreParziali(arg) {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getoreparziali",
          token: localStorage.user_token,
          id_commessa: arg,
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.overlay = false;
            this.items_ore_parziali = res.data.result.ore;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
            this.overlay = false;
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
          this.overlay = false;
          return false;
        });
    },
    getTabelle() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.user_token,
          tipo: "PARTE_BARCA",
          filter: "validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data) {
              res.data.sort((a, b) =>
                a.ordine < b.ordine ? -1 : a.ordine > b.ordine ? 1 : 0
              );
              this.items_colonne = res.data;
            } else {
              this.items_colonne = new Array();
            }
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    goBack() {
      this.$router.push("/home/electrical");
    },
    handleSalvaDichiarazione() {
      this.specifica_barca = false;
      this.getDiario();
    },
    handleSalvatoQuestionario() {
      // Chiudo il dialog della checklist
      this.questionario_visible = false;

      // Stampo una snackbar di conferma
      this.$refs.SnackbarQV.print(
        "success",
        `Checklist di collaudo aggiornata con successo!`
      );

      // Aggiorno la tabella
      this.getDiario();
    },
    handleSaveModOre() {
      this.$refs.SnackbarQV.print(
        "success",
        `Ore di attività registrate con successo.`
      );
      this.modifica_ore_diario = false;
      this.getDiario();
    },
    isColumnEnabled(arg, arg_param) {
      /* Vedo se trovo un'autorizzazione per la
       * famiglia della barca di specie. */
      const chk =
        arg.checklist_dettaglio.filter(
          (e) => e.des === arg_param && e.abilitato == 1
        ).length > 0;

      // Ritorno il risultato.
      return chk;
    },
    ripristina() {
      // Rendo invisibili i filtri e resetto le chiavi di filtro
      this.search = "";
      this.cod_search = "";
      this.commessa_search = "";
      this.filtri_visible = false;

      // Resetto le commesse visualizzati in tabella
      this.commesse = [];
      this.elem_commessa.forEach((e) => {
        this.commesse.push(Object.assign({}, e));
      });
    },
    async updateColonneDiario() {
      // Carico la lista delle dichiarazioni
      this.getDiario();

      /* Carico la lista delle colonne e compongo
       * le testate definitive della tabella. */
      await this.getTabelle();
      this.buildHeaders();
    },
  },
  created() {},
  async mounted() {
    // Valorizzo il cod_profilo per sapere quali bottoni si vedono
    this.cod_profilo = localStorage.cod_profilo;
    this.id_utente = localStorage.id;

    // Carico la lista delle dichiarazioni
    this.getDiario();

    /* Carico la lista delle colonne e compongo
     * le testate definitive della tabella. */
    await this.getTabelle();
    this.buildHeaders();
  },
};
</script>
<style scoped>
</style> 